<template>
  <!--页面的底部-->
  <div class="footer" v-if="links && links.length">
    <div class="footer-title">友情链接</div>
    <div class="navs">
      <a
        :href="target_url"
        v-for="{ name, target_url, id } in links"
        :key="id"
        target="_blank"
        class="nav"
        >{{ name }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {
    menu: Object
  },
  data() {
    return { links: [] };
  },
  created() {
    this.getLink();
  },
  methods: {
    async getLink() {
      const res = await this.$http.getFooterLink({ num: this.menu.num });
      this.links = res;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 120px;
  width: 100%;
  text-align: center;
  padding: 32px 0 20px;
  background: #222;
  &-title {
    font-size: 16px;
    color: #fff;
    line-height: 22px;
    margin-bottom: 12px;
  }
}

.footer .navs {
  margin-bottom: 47px;
}

.footer .navs .nav {
  display: inline-block;
  padding: 0 10px;
  border-right: 1px solid #fff;
  font-size: 12px;
  color: #fff;
  line-height: 12px;
  &:last-child {
    border-right: 0;
  }
}

// .footer .navs .nav + .nav {
//   margin-left: 20px;
// }

// .foot {
//   font-size: 14px;
//   color: #707070;
//   line-height: 20px;
//   text-align: center;
//   margin: 0 auto;
// }
</style>